module.exports = __webpack_public_path__ + "img/Medusa.f85481b9.png";